import { ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss']
})
export class VideoDialogComponent {
  videoUrl: string;
  videos: any[];
  currentVideoIndex: number = 0;

  @ViewChild('videoPlayer') videoElement: ElementRef | undefined;
  
  constructor(
    public dialogRef: MatDialogRef<VideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef
  ) {
    this.videoUrl = data.videoUrl;
    this.videos = data.videos;
    this.currentVideoIndex = data.currentVideoIndex;
  }

  ngAfterViewInit() {
    if (this.videoElement) {
      this.videoElement.nativeElement.play();
    }
  }

  playNextVideo() {
    const nextIndex = this.currentVideoIndex + 1;
    if (nextIndex < this.videos.length) {
      this.currentVideoIndex = nextIndex;
      this.videoUrl = this.videos[this.currentVideoIndex].url;
      this.cdr.detectChanges();
      if (this.videoElement) {
        this.videoElement.nativeElement.load();
        this.videoElement.nativeElement.play();
      }
    }
  }

  playPreviousVideo() {
    const prevIndex = this.currentVideoIndex - 1;
    if (prevIndex >= 0) {
      this.currentVideoIndex = prevIndex;
      this.videoUrl = this.videos[this.currentVideoIndex].url;
      this.cdr.detectChanges();
      if (this.videoElement) {
        this.videoElement.nativeElement.load();
        this.videoElement.nativeElement.play();
      }
    }
  }

  onVideoEnd() {
    this.playNextVideo();
  }

  closeDialog() {
    this.dialogRef.close({ next: this.currentVideoIndex });
  }
}
